@if (notification()) {
    <div
        id="outer-container"
        class="px-2 d-flex w-100 flex-column justify-content-center"
        [ngClass]="condensedView() ? 'mt-0' : 'mt-3'"
    >
        <div [ngClass]="condensedView() ? 'mb-0' : 'mb-2'">
            <strong>{{ notification().InstitutionBulkEnrollmentNotification?.ExamBankName }}</strong>
            has completed importing {{ allLearners() }}.

            @if (notification().InstitutionBulkEnrollmentNotification?.Failed === 0) {
                {{ notification().InstitutionBulkEnrollmentNotification?.Completed }}
                {{ completedLearners() }}
                were added to the subscription.
            } @else {
                {{ notification().InstitutionBulkEnrollmentNotification?.Completed }} of
                {{
                    this.notification().InstitutionBulkEnrollmentNotification?.Failed +
                        this.notification().InstitutionBulkEnrollmentNotification?.Completed
                }}
                {{ allLearners() }} were added to the subscription.
                {{ notification().InstitutionBulkEnrollmentNotification?.Failed }} {{ failedLearners() }} had errors
                which can be viewed in import history.
            }
        </div>
        <div [ngClass]="condensedView() ? 'mb-1' : 'mb-3'">
            <small>{{ date() }}</small>
        </div>
        <div class="d-flex flex-wrap" [ngClass]="condensedView() ? 'mb-2' : 'mb-3'">
            <div>
                <button
                    type="button"
                    class="text-nowrap my-1 me-1 btn btn-outline-secondary"
                    [ngClass]="condensedView() ? 'btn-sm' : 'btn-md'"
                    (click)="viewSubscription()"
                >
                    View Subscription
                </button>
            </div>

            <div>
                <button
                    id="import-history-btn"
                    type="button"
                    class="text-nowrap my-1 btn btn-outline-secondary"
                    (click)="viewImportHistory()"
                    [ngClass]="condensedView() ? 'btn-sm' : 'btn-md'"
                >
                    View Import History
                </button>
            </div>
        </div>
    </div>
}
